<template>
    <div 
      id="fileManagerModal" 
      class="modal"
      aria-hidden="true"
      aria-labelledby="fileManagerModalToggle"
      tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="fileManagerModalToggleLabel">
              {{$t("fileManager.fileManagerModal.title")}}
            </h5>
            <button type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="onCloseFileManagerModal">
            </button>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <ul>
                <li>{{ `Selecciona no más de ${maxFiles} fotos y arrastralas o seleccionadas desde tu computadora` }}</li>
                <li>Los archivos deben de ser .jpg</li>
                <li>No debe haber archivos que no sean .jpg ni que estén dañados</li>
              </ul>
            </div>
            <div class="col-md-12">
              <div class="uploader"
                @dragover.prevent
                @dragenter="onDragEnter"
                @dragleave="onDragLeave"
                @drop="onFileDrop"
                :class="{ dragging: isDragging }">
                <div>
                  <i class="fa fa-cloud-upload"></i>
                  <div class="file-input">
                    <button @click="onFilePicker">
                      <label for="file">
                        {{$t("fileManager.fileManagerModal.choosePhotos")}}
                      </label>
                    </button>
                  </div>
                </div>
              </div>
            </div>             
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" @click="onCloseFileManagerModal">
              {{$t("fileManager.fileManagerModal.cancel")}}
            </button>
          </div>            
        </div>
      </div>
    </div>
</template>

<script lang='js'>
import { integer } from 'vue-mc/validation';


// dragCount
export default {
  name: 'FileManagerModal',

  props: {
    maxFiles: {
      type: integer,
      default: 0
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dragCount: 0,
      isDragging: false,
      fileManagerModal: null,
    }
  },
  async mounted() {
    this.fileManagerModal = new bootstrap.Modal(document.getElementById('fileManagerModal'), {});
  },

  methods: {
    async onFilePicker() {
      const fileHandles = await window.showOpenFilePicker({ multiple: true });
      this.onCloseFileManagerModal();
      this.$emit('onSelectedFileHandles', fileHandles);
    },

    async onFileDrop(e) {
      e.preventDefault();
      const fileHandles = [...e.dataTransfer.items]
        .filter((item) => item.kind === 'file')
        .map((item) => item.getAsFileSystemHandle());

      this.onCloseFileManagerModal();
      this.$emit('onSelectedFileHandles', fileHandles);
    },

    onDragEnter(e) {
      e.preventDefault();
      this.dragCount++;
      this.isDragging = true;
      return false;
    },

    onDragLeave(e) {
      e.preventDefault();
      this.dragCount--;
      if(this.dragCount <= 0)
        this.isDragging = false;
    },

    onOpenFileManagerModal() {
      this.fileManagerModal.show();
    },

    onCloseFileManagerModal() {
      this.fileManagerModal.hide();
      this.$emit('onClose');
    },  
  },

  watch: {
    open: function(newVal) {
      if(newVal) {
        this.onOpenFileManagerModal();
      } else {
        this.onCloseFileManagerModal();
      }
    }
  }

};
</script>

<style lang="scss" scoped>
  .uploader .file-input {
    width: 100%;;
  }

  .uploader.dragging .file-input label {
    background: transparent;
    color: #87898C;
  }
</style>